import { VehicleOccupancyModel } from './../models/vehicle-occupancy.model';
import { ReportFilterModel } from './../models/report-filter.model';
import { NgModel } from '@angular/forms';
import { ApplicationRouteURL, IKeyValueInterface, DataListModel, WeGoConfig, RoleLevel } from './../../shared/config';
import { AuthService } from './../../shared/models/auth.service';
import { VehicleOccupancyService } from './../models/vehicle-occupancy.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wego-vehicle-occupancy-report',
  template: require('../views/vehicle-occupancy.component.html'),
  providers: [VehicleOccupancyService],
  styles: [`
          .box-body{
            padding: 0px 10px 10px;
          }
          .checkbox-inline{
            padding-left: 0px !important;
          }         
          `
  ]
})
export class VehicleOccupancy implements OnInit {
  itemPerPageList: number[];
  itemsPerPage: number;
  urlDefaultPage: any;
  isLoading: boolean;
  isValidSearch: boolean = false;
  errorModel: IKeyValueInterface[];
  reportName: string;
  listOfVehicleOccupancyModel: VehicleOccupancyModel[];
  // listOfFilterRecord: any;
  public listOfFilterRecord: any[];
  DataListModel: DataListModel;
  roleLevel = RoleLevel;

  constructor(private authService: AuthService
    , private vehicleOccupancyService: VehicleOccupancyService) {
  }

  ngOnInit() {
    this.reportName = "Vehicle_Occupancy_Report";
    this.itemPerPageList = WeGoConfig.GRID_PAGGING;
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.ResetPaging();
  }

  public OnSearch($event: any) {
    this.ResetPaging();
    this.isLoading = true;
    let model: ReportFilterModel = $event.model;
    this.vehicleOccupancyService.GenerateVehicleOccupancyReport(model).subscribe(
      res => {
        if (!res.data) {
          this.isValidSearch = false;
          this.errorModel = res.error;
          this.isLoading = false;
        }
        else {
          this.isValidSearch = res.data.length > 0 ? true : false;
          this.errorModel = null;
          this.listOfVehicleOccupancyModel = res.data;
          this.DataListModel.totalItems = res.data.length;
          this.DataListModel.infoMessage = res.error;
          this.FilterList();
          this.isLoading = false;
        }
      },
      error => {
        this.authService.HandleErrorStatusCode(error);
        this.listOfVehicleOccupancyModel = [];
        this.FilterList();
      });
  }

  public OnExportPDF($event: any) {
    this.isLoading = true;
    let model: ReportFilterModel = $event.model;
    this.vehicleOccupancyService.ExportVehicleOccupancyReportPDF(model)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "VehicleOccupancyReport" + new Date().toISOString() + ".pdf";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public OnExportExcel($event: any) {
    this.isLoading = true;
    let model: ReportFilterModel = $event.model;
    this.vehicleOccupancyService.ExportVehicleOccupancyReportExcel(model)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "VehicleOccupancyReport" + new Date().toISOString() + ".xlsx";
          this.authService.DownloadXlsFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public ResetValidSearch($event: any) {
    let isValidSearch: boolean = $event.isValidSearch;
    this.isValidSearch = isValidSearch;
    this.listOfVehicleOccupancyModel = [];
    this.listOfFilterRecord = [];
    this.DataListModel.totalItems = 0;
  }

  // Client side paging event
  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.itemsPerPage = parseInt(event);
    this.FilterList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.FilterList();
  }

  public FilterList() {
    let start = this.DataListModel.itemsPerPage * (this.DataListModel.currentPage - 1);
    let end = start + (this.DataListModel.itemsPerPage);
    this.listOfFilterRecord = this.listOfVehicleOccupancyModel.slice(start, end);
  }

  public ResetPaging() {
    this.listOfVehicleOccupancyModel = [];
    this.listOfFilterRecord = [];
    this.DataListModel = new DataListModel();
    this.DataListModel.itemsPerPage = 10;
    this.itemsPerPage = 10;
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/report/components/vehicle-occupancy.component.ts